import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TEmptyObject } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useQueryFlexidasActiveAlarmFilters } from './useQueryFlexidasActiveAlarmFilters';
import { useQueryLimenetActiveAlarmFilters } from './useQueryLimenetActiveAlarmFilters';
import { useQueryOranActiveAlarmFilters } from './useQueryOranActiveAlarmFilters';

const getAlarmsFilters = ({
	flexidas,
	limenet,
	oran,
	vendor,
}: {
	flexidas: IAlarmByVendorFilter;
	limenet: IAlarmByVendorFilter;
	oran: IAlarmByVendorFilter;
	vendor: string;
}): TEmptyObject | IAlarmByVendorFilter => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return flexidas;
		case EVendorsValues.limenet:
			return limenet;
		case EVendorsValues.oran:
			return oran;
		default:
			return {};
	}
};

interface IUseActiveAlarmFiltersReturned {
	filtersList: IAlarmFilter[];
	isLoadingFilters: boolean;
}

export interface IAlarmFiltersProps {
	vendor: string;
	isActiveTab: boolean;
}

export const useAlarmFilters = ({ vendor, isActiveTab }: IAlarmFiltersProps): IUseActiveAlarmFiltersReturned => {
	const limenet = useQueryLimenetActiveAlarmFilters({ vendor, isActiveTab });
	const flexidas = useQueryFlexidasActiveAlarmFilters({ vendor, isActiveTab });
	const oran = useQueryOranActiveAlarmFilters({ vendor, isActiveTab });

	const { filters = [], isLoading = false } = getAlarmsFilters({
		flexidas,
		limenet,
		oran,
		vendor,
	});

	return {
		filtersList: filters,
		isLoadingFilters: isLoading,
	};
};
